import AuditStep4 from '../../AuditCreationModal/AuditStep4/AuditStep4';

const ProcessAuditStep4 = (props) => {
	return <AuditStep4 {...props} />;
};

export default ProcessAuditStep4;
